export const POST_REQUEST = "POST_REQUEST";
export const POST_ERROR = "POST_ERROR";
export const POST_SUCCESS = "POST_SUCCESS";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const FETCH_POST_BY_ID = "FETCH_POST_BY_ID";

export const GET_POST_ID = "GET_POST_ID";
export const RESET_POST_ID = "RESET_POST_ID";
export const UPDATE_POST = "UPDATE_POST";
export const DELETE_POST = "DELETE_POST";
export const LIKE_POST = "LIKE_POST";
export const COMMENT_POST = "COMMENT_POST";
export const COMMENT_DELETE = "COMMENT_DELETE";

export const RESET_POST_STATE = "RESET_POST_STATE";
